var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "12px",
    viewBox: "0 0 11 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4.2Mas") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.7Reservaciones",
    transform: "translate(-1064.000000, -636.000000)",
    stroke: "#65748B",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(735.500000, 205.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(0.000000, 404.272078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(277.500000, 17.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.2Mas",
    transform: "translate(52.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 4.5,
    y1: 0,
    x2: 4.5,
    y2: 9,
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 4.5,
    x2: 9,
    y2: 4.5,
    id: "Stroke-3"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMas);
export default __webpack_public_path__ + "static/media/Mas.22d82c6830106ca2483edceef9376816.svg";
export { ForwardRef as ReactComponent };